import { E_ROUTER_NAME, E_ROUTER_PARAMS } from '@pharmsnap/pharmsnap-web/types/enum'
import { RouteConfig } from 'vue-router'

export default [
  {
    path: `target/:${E_ROUTER_PARAMS.TARGET_ID}`,
    name: E_ROUTER_NAME.TARGET,
    props: (route) => ({
      id: route.params[E_ROUTER_PARAMS.TARGET_ID],
    }),
    component: () => import('@pharmsnap/pharmsnap-web/views/target/TargetDetail'),
    meta: {
      notWide: true,
      trackingRouteName: E_ROUTER_NAME.TARGET_DETAIL,
    },
    children: [
      {
        path: 'overview',
        name: E_ROUTER_NAME.TARGET_OVERVIEW,
        redirect: () => {
          return {
            name: E_ROUTER_NAME.TARGET,
          }
        },
      },
    ],
  },
] as RouteConfig[]
